import Vue from "vue";
import Router from "vue-router";
import SecureLS from "secure-ls";
import GoogleAnalyticsService from "./core/services/analytics/google-analytics.service";
import { executeMiddleware } from "@/core/middleware";

const ls = new SecureLS({ encodingType: "aes", isCompression: true });
Vue.use(Router);
import { hasPermission } from "@/core/mixin/general.mixin";
const router = new Router({
  // mode: "history",
  base: "/",
  routes: [
    // {
    //   path: "",
    //   redirect: "/dashboard",
    // },
    {
      path: "/",
      redirect: "/homepage",
    },
    {
      path: "",
      redirect: "/homepage",
    },
    {
      path: "/homepage",
      name: "homepage",
      component: () => import("@/view/homepage/homepage.vue"),
      meta: { permission: null, guest: true },
    },
    {
      path: "/dashboard",
      redirect: "/dashboard",
      mode: "history",
      component: () => import("@/view/layouts/user/UserLayout"),
      children: [
        {
          path: "/test",
          component: () => import("@/view/test/Test"),
        },
        {
          path: "/dashboard",
          name: "user.index",
          component: () => import("@/view/User/Home/Index.vue"),
        },
        {
          path: "/user/:id/show",
          name: "user.show",
          component: () => import("@/view/User/UserShow"),
        },
        {
          path: "/profile",
          name: "user.profile",
          component: () => import("@/view/User/Profile"),
        },
        {
          path: "/payment-callback",
          name: "user.payment-callback",
          component: () => import("@/view/User/PaymentCallback"),
        },
        {
          path: "/update-invoice",
          name: "user.update-invoice",
          component: () => import("@/view/User/UpdateInvoice"),
        },
        {
          path: "/update-profile",
          name: "user.update-profile",
          component: () => import("@/view/User/UpdateProfile"),
        },
        {
          path: "/my-assignment",
          name: "user.my-assignment",
          component: () => import("@/view/User/MyAssignments/index.vue"),
        },
        {
          path: "/providers-trainings/:provider?",
          name: "user.providers-trainings",
          component: () => import("@/view/User/ProviderResults/index.vue"),
        },
        {
          path: "/assignment/:id/detail",
          name: "user.assignment-detail",
          component: () => import("@/view/User/AssignmentDetails"),
        },
        {
          path: "/my-statistics",
          name: "user.my-statistics",
          component: () => import("@/view/User/MyStatistics/index.vue"),
        },
        {
          path: "/my-development-competencies",
          name: "user.my-development",
          component: () =>
            import("@/view/User/MyDevelopmentCompetencies/Index.vue"),
        },
        {
          path: "/my-development-competencies/competency-detail/:userCompetencyId",
          name: "user.my-development.competency",
          props: true,
          component: () =>
            import("@/view/User/MyDevelopmentCompetencies/Detail.vue"),
        },
        {
          path: "/my-team",
          name: "user.my-team",
          component: () => import("@/view/User/MyTeam/Index.vue"),
        },
        {
          path: "/my-team-member-competencies/:userId",
          name: "user.my-team.member",
          props: true,
          component: () => import("@/view/User/MyTeam/MemberCompetencies.vue"),
        },
        {
          path: "/my-team-member/:userId/competency-detail/:userCompetencyId",
          name: "user.my-team.competency",
          props: true,
          component: () =>
            import("@/view/User/MyTeam/MemberCompetencyDetail.vue"),
        },
        {
          path: "/education/:id/detail",
          name: "user.education-detail",
          component: () => import("@/view/User/EducationDetails/index.vue"),
        },
        {
          path: "/education-category",
          name: "user.education-category",
          component: () => import("@/view/User/EducationCatalog/index.vue"),
        },
        {
          path: "/search",
          name: "User.search",
          component: () => import("@/view/User/Search"),
        },
        {
          path: "/notification/:id?",
          name: "dashboard.notification",
          props: true,
          component: () => import("@/view/User/Notification/index.vue"),
          // meta: { permission: "read_notice" },
        },
        {
          path: "/duel",
          name: "User.duel",
        },
        {
          path: "/wall/:id?",
          name: "user.wall",
          props: true,
          component: () => import("@/view/User/Wall/index.vue"),
        },
        {
          path: "/gift",
          name: "user.gift",
          component: () => import("@/view/User/Gift/index.vue"),
        },
        {
          path: "/my-collection",
          name: "user.my-collection",
          component: () => import("@/view/User/Collections/MyCollection.vue"),
        },
        {
          path: "/collection/:id/detail",
          name: "user.collection-detail",
          component: () => import("@/view/User/CollectionDetails/index.vue"),
        },
        {
          path: "/messages/:id?",
          name: "User.messages",
          props: true,
          component: () => import("@/view/User/Messages/index.vue"),
          beforeEnter: executeMiddleware(["chatAccess"]),
        },
        {
          path: "/my-certification",
          name: "User.my-certification",
          component: () => import("@/view/User/MyCertificates/index.vue"),
        },
        {
          path: "/payment-history",
          name: "User.payment-history",
          component: () => import("@/view/User/PaymentHistory"),
        },
        {
          path: "/agenda",
          name: "user.agenda",
          component: () => import("@/view/User/Agenda/index.vue"),
        },
        {
          path: "/solution_partners_apps",
          name: "user.solution_partners_apps",
          component: () => import("@/view/User/Partner"),
        },
        {
          path: "/faq",
          name: "User.faq",
          component: () => import("@/view/User/FAQ"),
        },
        {
          path: "/legal-notification",
          name: "User.agreement",
          component: () => import("@/view/User/Agreement"),
        },
        {
          path: "/assignments/:assignment/classroom-education",
          name: "user.classroom-education",
          component: () => import("@/view/User/ClassRoomEducation"),
        },
      ],
    },
    {
      path: "/admin",
      redirect: "/admin/dashboard",
      mode: "history",
      component: () => import("@/view/layouts/admin/AdminLayout"),
      children: [
        {
          path: "/admin/dashboard",
          name: "company.dashboard",
          component: () => import("@/view/company/HomeDashboard/Index.vue"),
        },
        {
          path: "/admin/user",
          name: "company.user.index",
          component: () => import("@/view/company/User/Users/index.vue"),
        },
        {
          path: "/admin/user/list",
          name: "company.user.list",
          component: () => import("@/view/company/User/Users/index.vue"),
        },
        {
          path: "/admin/user/add",
          name: "company.user.add",
          component: () => import("@/view/company/User/UserAdd"),
        },
        {
          path: "/admin/user/edit/:id",
          name: "company.user.edit",
          component: () => import("@/view/company/User/UserEdit"),
        },
        {
          path: "/admin/user/group",
          name: "company.user.group",
          component: () => import("@/view/company/User/Group/List"),
        },
        {
          path: "/admin/user/group/add",
          name: "company.user.group.add",
          component: () =>
            import("@/view/company/User/Group/UserGroupAddUpdate"),
        },
        {
          path: "/admin/user/group/edit/:id",
          name: "company.user.group.edit",
          component: () =>
            import("@/view/company/User/Group/UserGroupAddUpdate"),
        },
        {
          path: "/admin/user/passive",
          name: "company.user.passive.list",
          component: () => import("@/view/company/User/UserPassive"),
          meta: { permission: "show_user" },
        },
        {
          path: "/admin/user/hierarchy",
          name: "company.user.hierarchy",
          component: () => import("@/view/company/User/Hierarchy"),
          // meta: { permission: "show_user" },
        },
        {
          path: "/admin/instructors",
          redirect: "/admin/instructors/list",
        },
        {
          path: "/admin/instructors/list",
          name: "company.instructors.list",
          component: () => import("@/view/company/Instructors/List.vue"),
          meta: { permission: "read_instructor" },
        },
        {
          path: "/admin/instructors/add",
          name: "company.instructors.add",
          component: () => import("@/view/company/Instructors/Add.vue"),
          meta: { permission: "create_instructor" },
        },
        {
          path: "/admin/instructors/edit/:id",
          name: "company.instructors.edit",
          component: () => import("@/view/company/Instructors/Add.vue"),
          meta: { permission: "update_instructor" },
        },
        {
          path: "/admin/content/add",
          name: "company.content.add",
          component: () =>
            import("@/view/company/Content/ContentAddUpdate.vue"),
          meta: { permission: "create_content" },
        },

        {
          path: "/admin/education/catalog/add",
          name: "company.content.catalog.add",
          component: () =>
            import("@/view/company/CatalogEducation/CatalogContentAddUpdate"),
          meta: { permission: "create_training" },
        },
        {
          path: "/admin/education/catalog/edit/:id",
          name: "company.education.catalog.edit",
          component: () =>
            import("@/view/company/CatalogEducation/CatalogContentAddUpdate"),
          meta: { permission: "create_training" },
        },
        {
          path: "/admin/content",
          name: "company.contents.all",
          component: () => import("@/view/company/Content/ContentList.vue"),
          meta: { permission: "read_content" },
        },
        {
          path: "/admin/content/archive",
          name: "company.contents.archive",
          component: () => import("@/view/company/Content/ContentArchive"),
          meta: { permission: "read_content" },
        },
        {
          path: "/admin/content/edit/:id",
          name: "company.contents.edit",
          component: () =>
            import("@/view/company/Content/ContentAddUpdate.vue"),
          meta: { permission: "create_content" },
        },
        {
          path: "/admin/content/detail/:id",
          name: "company.contents.detail",
          component: () => import("@/view/company/Content/ContentDetail.vue"),
          meta: { permission: "read_contentdetailreport" },
        },
        {
          path: "/admin/content/:id/preview",
          name: "company.contents.preview",
          component: () => import("@/view/company/Content/ContentList.vue"),
          meta: { permission: "read_content" },
        },
        {
          path: "/admin/content/:id/assignment",
          name: "company.contents.assignment",
          component: () => import("@/view/company/Content/ContentList.vue"),
          meta: { permission: "read_content" },
        },
        {
          path: "/admin/program",
          name: "company.programs.all",
          component: () => import("@/view/company/Program/List"),
          meta: { permission: "read_program" },
        },
        {
          path: "/admin/program/add",
          name: "company.program.add",
          component: () => import("@/view/company/Program/ProgramAddUpdate"),
          meta: { permission: "create_program" },
        },
        {
          path: "/admin/program/edit/:id",
          name: "company.programs.edit",
          component: () => import("@/view/company/Program/ProgramAddUpdate"),
          meta: { permission: "create_program" },
        },
        {
          path: "/admin/settings",
          name: "company.setting",
          component: () => import("@/view/company/Settings/Settings.vue"),
          meta: { permission: "read_companysetting" },
        },
        {
          path: "/admin/data",
          name: "company.data",
          component: () => import("@/view/company/Data"),
        },
        {
          path: "/admin/companies",
          name: "company.companies.list",
          component: () => import("@/view/company/Companies/List"),
        },
        {
          path: "/admin/companies/add",
          name: "company.companies.add",
          component: () => import("@/view/company/Companies/Add"),
        },
        {
          path: "/admin/companies/edit/:id",
          name: "company.companies.edit",
          component: () => import("@/view/company/Companies/Edit"),
        },
        {
          path: "/admin/institutions",
          name: "company.institutions.list",
          component: () => import("@/view/company/Institution/List"),
        },
        {
          path: "/admin/institutions/add",
          name: "company.institutions.add",
          component: () => import("@/view/company/Institution/Add"),
        },
        {
          path: "/admin/institutions/edit/:id",
          name: "company.institutions.edit",
          component: () => import("@/view/company/Institution/Edit"),
        },
        {
          path: "/admin/question/add",
          name: "company.question.add",
          component: () => import("@/view/company/Question/Add"),
        },
        {
          path: "/admin/question/edit/:id",
          name: "company.question.edit",
          component: () => import("@/view/company/Question/Edit"),
        },
        {
          path: "/admin/questions",
          name: "company.questions.list",
          component: () => import("@/view/company/Question/List"),
        },
        {
          path: "/admin/surveys",
          name: "company.surveys.list",
          component: () => import("@/view/company/Survey/List"),
          meta: { permission: "show_survey" },
        },
        {
          path: "/admin/survey/add",
          name: "company.survey.add",
          component: () => import("@/view/company/Survey/SurveyAddEdit"),
          meta: { permission: "create_survey" },
        },
        {
          path: "/admin/survey/:id/edit",
          name: "company.survey.edit",
          component: () => import("@/view/company/Survey/SurveyAddEdit"),
          meta: { permission: "create_survey" },
        },
        {
          path: "/admin/evaluation-surveys",
          name: "company.evaluation-surveys.list",
          component: () => import("@/view/company/EvaluationSurvey/List"),
          meta: { permission: "read_evaluationsurvey" },
        },
        {
          path: "/admin/evaluation-survey/add",
          name: "company.evaluation-survey.add",
          component: () =>
            import("@/view/company/EvaluationSurvey/AddEditEvaluationSurvey"),
          meta: { permission: "create_evaluationsurvey" },
        },
        {
          path: "/admin/evaluation-survey/:id/edit",
          name: "company.evaluation-survey.edit",
          component: () =>
            import("@/view/company/EvaluationSurvey/AddEditEvaluationSurvey"),
          meta: { permission: "create_evaluationsurvey" },
        },
        {
          path: "/admin/exams",
          name: "company.exams.list",
          component: () => import("@/view/company/Exam/List"),
          meta: { permission: "show_exam" },
        },
        {
          path: "/admin/exam/add-demo",
          name: "company.exam.add-demo",
          component: () => import("@/view/company/Exam/Add-demo"),
          meta: { permission: "create_exam" },
        },
        {
          path: "/admin/exam/:id/edit-demo",
          name: "company.exam.edit-demo",
          component: () => import("@/view/company/Exam/Edit-demo"),
          meta: { permission: "create_exam" },
        },
        {
          path: "/admin/certificates",
          name: "company.certificate.list",
          component: () => import("@/view/company/Certificates/List"),
          meta: { permission: "show_certificate" },
        },
        {
          path: "/admin/certificate/add",
          name: "company.certificate.add",
          component: () =>
            import("@/view/company/Certificates/AddEditCertificates"),
          meta: { permission: "create_certificate" },
        },
        {
          path: "/admin/certificate/:id/edit",
          name: "company.certificate.edit",
          component: () =>
            import("@/view/company/Certificates/AddEditCertificates"),
          meta: { permission: "create_certificate" },
        },
        {
          path: "/admin/hashtags",
          name: "company.hashtags.list",
          component: () => import("@/view/company/Hashtags/List"),
          meta: { permission: "show_hashtag" },
        },
        {
          path: "/admin/hashtags/add",
          name: "company.hashtags.add",
          component: () => import("@/view/company/Hashtags/HashtagAddUpdate"),
          meta: { permission: "create_hashtag" },
        },
        {
          path: "/admin/hashtags/:id/edit",
          name: "company.hashtags.edit",
          component: () => import("@/view/company/Hashtags/HashtagAddUpdate"),
          meta: { permission: "create_hashtag" },
        },
        {
          path: "/admin/certificate-templates",
          name: "company.certificate_template.list",
          component: () => import("@/view/company/CertificateTemplates/List"),
          meta: { permission: "show_certificatetemplate" },
        },
        {
          path: "/admin/certificate-template/add",
          name: "company.certificate_template.add",
          component: () => import("@/view/company/CertificateTemplates/Add"),
          meta: { permission: "create_certificatetemplate" },
        },
        {
          path: "/admin/certificate-template/:id/edit",
          name: "company.certificate_template.edit",
          component: () => import("@/view/company/CertificateTemplates/Edit"),
          meta: { permission: "create_certificatetemplate" },
        },
        {
          path: "/admin/points",
          name: "company.point.list",
          component: () => import("@/view/company/Points/List"),
          meta: { permission: "read_point" },
        },
        {
          path: "/admin/point/:id/update",
          name: "company.point.update",
          component: () => import("@/view/company/Points/Edit"),
        },
        {
          path: "/admin/menu-modules",
          name: "company.menu_modules.list",
          component: () => import("@/view/company/Module/List"),
          meta: { permission: "read_widgetmanagement" },
        },
        {
          path: "/admin/gifts",
          name: "company.gift.list",
          component: () => import("@/view/company/Gifts/List"),
          meta: { permission: "show_gift" },
        },
        {
          path: "/admin/gift/add",
          name: "company.gift.add",
          component: () => import("@/view/company/Gifts/Add"),
          meta: { permission: "create_gift" },
        },
        {
          path: "/admin/gift/:id/edit",
          name: "company.gift.edit",
          component: () => import("@/view/company/Gifts/Edit"),
          meta: { permission: "create_gift" },
        },
        {
          path: "/admin/gift/requests",
          name: "company.gift.requests",
          component: () => import("@/view/company/Gifts/Request"),
          meta: { permission: "read_gift" },
        },
        {
          path: "/admin/share-management",
          name: "company.management.share",
          component: () => import("@/view/company/ShareManagement/Shares"),
          meta: { permission: "read_sharesmanagement" },
        },
        {
          path: "/admin/collection-management",
          name: "company.management.collection",
          component: () =>
            import("@/view/company/ShareManagement/Collections.vue"),
        },
        {
          path: "/admin/order-management",
          name: "company.management.order",
          component: () => import("@/view/company/OrderManagement/Orders"),
          meta: { permission: "read_ordermanagement" },
        },
        {
          path: "/admin/payment-history",
          name: "company.payment_history.content",
          component: () => import("@/view/company/PaymentHistory/Content"),
          meta: { permission: "read_paymenttransaction" },
        },
        {
          path: "/admin/content-management",
          name: "company.management.content",
          component: () => import("@/view/company/ShareManagement/Content"),
        },
        {
          path: "/admin/competency-management",
          name: "company.management.competency",
          component: () =>
            import("@/view/company/ShareManagement/Competencies.vue"),
          meta: { permission: "read_competency" },
        },
        {
          path: "/admin/mail-templates",
          name: "company.mail.templates2",
          component: () => import("@/view/company/Mail/Template2"),
        },
        {
          path: "/admin/assignments",
          name: "company.assignments.list",
          component: () => import("@/view/company/Assignments/List"),
          meta: { permission: "read_assignment" },
        },
        {
          path: "/admin/assignments-passive",
          name: "company.assignments.list-passive",
          component: () => import("@/view/company/Assignments/List"),
          meta: { permission: "read_assignment" },
        },
        {
          path: "/admin/auto-assignments",
          name: "company.assignments.auto",
          component: () => import("@/view/company/Assignments/Auto"),
          meta: { permission: "read_assignment" },
        },
        {
          path: "/admin/auto-assignments/add",
          name: "company.assignments.addAuto",
          component: () =>
            import("@/view/company/Assignments/AddUpdateAutoAssignments"),
          meta: { permission: "create_assignment" },
        },
        {
          path: "/admin/auto-assignments/:id/edit",
          name: "company.assignments.editAuto",
          component: () =>
            import("@/view/company/Assignments/AddUpdateAutoAssignments"),
          meta: { permission: "create_assignment" },
        },
        {
          path: "/admin/assignment/add/:id?",
          name: "company.assignments.add",
          component: () =>
            import("@/view/company/Assignments/AssignmentAddUpdate"),
          meta: { permission: "create_assignment" },
        },
        {
          path: "/admin/assignment/:id/edit",
          name: "company.assignments.edit",
          component: () =>
            import("@/view/company/Assignments/AssignmentAddUpdate"),
          meta: { permission: "create_assignment" },
        },
        {
          path: "/admin/assignment/:id/preview",
          name: "company.assignments.preview",
          component: () => import("@/view/company/Assignments/Preview"),
          meta: { permission: "read_assignment" },
        },

        //yetkinlik atamaları
        {
          path: "/admin/automatic-competency-definitions",
          name: "automatic.competency.definitions",
          component: () =>
            import(
              "@/view/company/CompetenciesDefinitions/automaticCompetency/ListAutoCompetency.vue"
            ),
          meta: { permission: "read_automaticcompetency" },
        },
        {
          path: "/admin/competencies-and-user-definitions",
          name: "competencies.and.user.definitions",
          component: () =>
            import(
              "@/view/company/CompetenciesDefinitions/competencies/ListCompetenciesAndUserDefinitions.vue"
            ),
          meta: { permission: "read_competency" },
        },
        {
          path: "/admin/development-evaluation",
          name: "company.development-evaluation.index",
          component: () =>
            import("@/view/company/DevelopmentEvaluation/Index.vue"),
          meta: { permission: "read_competency" },
        },
        {
          path: "/admin/development-evaluation/user/:userId",
          name: "company.development-evaluation.user",
          props: true,
          component: () =>
            import("@/view/company/DevelopmentEvaluation/UserDetail.vue"),
          meta: { permission: "read_competency" },
        },
        {
          path: "/admin/development-evaluation/user/:userId/competency/:userCompetencyId",
          name: "company.development-evaluation.competency",
          props: true,
          component: () =>
            import("@/view/company/DevelopmentEvaluation/CompetencyDetail.vue"),
          meta: { permission: "read_competency" },
        },
        {
          path: "/admin/add-automatic-competency",
          name: "add.automatic.competency",
          component: () =>
            import(
              "@/view/company/CompetenciesDefinitions/automaticCompetency/AddUpdateAutoCompetencies.vue"
            ),
          meta: { permission: "create_automaticcompetency" },
        },
        {
          path: "/admin/edit-automatic-competency/:id/edit",
          name: "edit.automatic.competency",
          component: () =>
            import(
              "@/view/company/CompetenciesDefinitions/automaticCompetency/AddUpdateAutoCompetencies.vue"
            ),
          meta: { permission: "create_automaticcompetency" },
        },
        //yetkinlik atamaları

        {
          path: "/admin/education/detail",
          name: "company.education.detail",
          component: () => import("@/view/company/Educations/Detail"),
        },
        {
          path: "/admin/advertisement",
          name: "company.advertisement.list",
          component: () => import("@/view/company/Advertisement/List"),
        },
        {
          path: "/admin/advertisement/add",
          name: "company.advertisement.add",
          component: () => import("@/view/company/Advertisement/Add"),
        },
        {
          path: "/admin/advertisement/:id/edit",
          name: "company.advertisement.edit",
          component: () => import("@/view/company/Advertisement/Edit"),
        },
        {
          path: "/admin/announcement",
          name: "company.announcement.list",
          component: () => import("@/view/company/Announcement/List"),
        },
        {
          path: "/admin/announcement/add",
          name: "company.announcement.add",
          component: () => import("@/view/company/Announcement/Add"),
        },
        {
          path: "/admin/announcement/:id/edit",
          name: "company.announcement.edit",
          component: () => import("@/view/company/Announcement/Edit"),
        },
        {
          path: "/admin/education/catalog",
          name: "company.education.catalog.list",
          component: () =>
            import("@/view/company/CatalogEducation/CatalogEducation"),
          meta: { permission: "show_training" },
        },

        {
          path: "/admin/education/catalog/purchased",
          name: "company.education.catalog.purchased",
          component: () =>
            import("@/view/company/CatalogEducation/CatalogEducationPurchased"),
          meta: { permission: "read_training" },
        },

        {
          path: "/admin/requests/user",
          name: "company.requests.user",
          component: () =>
            import("@/view/company/RequestsAndDemands/UserRequests"),
          meta: { permission: "read_training" },
        },
        {
          path: "/admin/requests/training/:id",
          name: "company.requests.training",
          component: () =>
            import("@/view/company/RequestsAndDemands/EducationDetails"),
          meta: { permission: "read_training" },
        },
        {
          path: "/admin/requests/purchase",
          name: "company.requests.purchase",
          component: () =>
            import("@/view/company/RequestsAndDemands/PurchaseRequests"),
          meta: { permission: "read_training" },
        },
        {
          path: "/admin/reports/statistics",
          name: "company.reports.statistics",
          component: () => import("@/view/company/Reports/Statistics"),
          meta: { permission: "read_report" },
        },
        {
          path: "/admin/reports/user-assignment-general-report",
          name: "company.reports.userAssignmentGeneralReport",
          component: () =>
            import("@/view/company/Reports/UserAssignmentGeneralReport"),
        },
        {
          path: "/admin/reports/institutions",
          name: "company.reports.institutions",
          component: () => import("@/view/company/Reports/Institutions"),
          meta: { permission: "read_institutionreport" },
        },
        {
          path: "/admin/reports/licences",
          name: "company.reports.licences",
          component: () => import("@/view/company/Reports/Licences"),
          meta: { permission: "read_companycontractreport" },
        },
        {
          path: "/admin/reports/certificates",
          name: "company.reports.certificates",
          component: () => import("@/view/company/Reports/Certificates"),
          meta: { permission: "read_certificatereport" },
        },
        {
          path: "/admin/reports/survey-reports",
          name: "company.reports.surveyReports",
          component: () => import("@/view/company/Reports/SurveyResults"),
          meta: { permission: "read_usersurveyresultreport" },
        },
        // {
        //   path: "/admin/reports/evaluation-survey-reports",
        //   name: "company.reports.evaluationSurveyReports",
        //   component: () =>
        //     import("@/view/company/Reports/EvaluationSurveyResults"),
        //   meta: { permission: "read_userevaluationsurveyresultreport" },
        // },
        {
          path: "/admin/reports/education-end-general-evaluation-report",
          name: "company.reports.educationEndGeneralEvaluationReport",
          component: () =>
            import(
              "@/view/company/Reports/EducationEndGeneralEvaluationReport"
            ),
          meta: { permission: "read_educationenddetailevaluationreport" },
        },
        {
          path: "/admin/reports/education-end-detail-evaluation-report",
          name: "company.reports.educationEndDetailEvaluationReport",
          component: () =>
            import("@/view/company/Reports/EducationEndDetailEvaluationReport"),
          meta: { permission: "read_userassignmentdetailreport" },
        },
        {
          path: "/admin/reports/gifts",
          name: "company.reports.gifts",
          component: () => import("@/view/company/Reports/Gifts"),
          meta: { permission: "read_giftreport" },
        },
        {
          path: "/admin/reports/users",
          name: "company.reports.users",
          component: () => import("@/view/company/Reports/Users"),
          meta: { permission: "read_userreport" },
        },
        {
          path: "/admin/reports/user-cumulative-reports",
          name: "company.reports.userCumulative",
          component: () => import("@/view/company/Reports/UserCumulative"),
          meta: { permission: "read_usereducationcumulativereport" },
        },
        // {
        //   path: "/admin/reports/assignments",
        //   name: "company.reports.assignments",
        //   component: () => import("@/view/company/Reports/Assignments"),
        //   meta: { permission: "read_userassignmentreport" },
        // },
        {
          path: "/admin/reports/user-assignments",
          name: "company.reports.userAssignments",
          component: () => import("@/view/company/Reports/UserAssignment"),
          meta: { permission: "read_userassignmentreport" },
        },
        {
          path: "/admin/reports/self-registiration",
          name: "company.reports.selfRegistiration",
          component: () => import("@/view/company/Reports/SelfRegistiration"),
          meta: { permission: "read_usertrainingreport" },
        },
        {
          path: "/admin/reports/contents",
          name: "company.reports.contents",
          component: () => import("@/view/company/Reports/Contents"),
          meta: { permission: "read_contentreport" },
        },
        {
          path: "/admin/reports/user-contents",
          name: "company.reports.userContents",
          component: () => import("@/view/company/Reports/UserContent"),
          meta: { permission: "read_usercontentreport" },
        },
        {
          path: "/admin/reports/exams",
          name: "company.reports.exams",
          component: () => import("@/view/company/Reports/Exams"),
          meta: { permission: "read_examreport" },
        },
        {
          path: "/admin/reports/exam-results",
          name: "company.reports.examResults",
          component: () => import("@/view/company/Reports/ExamResults"),
          meta: { permission: "read_examresultreport" },
        },
        {
          path: "/admin/reports/linkedin-learning",
          name: "company.reports.linkedin-learning",
          component: () =>
            import("@/view/company/Reports/LinkedinLearning.vue"),
          meta: { permission: "read_linkedinlearningreport" },
        },
        {
          path: "/admin/reports/udemy-reports",
          name: "company.reports.udemy-reports",
          component: () => import("@/view/company/Reports/UdemyReports.vue"),
          meta: { permission: "read_udemyreport" },
        },
        {
          path: "/admin/reports/harvard-business-reports",
          name: "company.reports.harvard-business-reports",
          component: () =>
            import("@/view/company/Reports/HarvardBusinessReports.vue"),
          meta: { permission: "read_harvardreport" },
        },
        {
          path: "/admin/reports/external-source-reports",
          name: "company.reports.external-source-reports",
          component: () =>
            import("@/view/company/Reports/ExternalSourceReports.vue"),
          meta: { permission: "read_externalreport" },
        },
        {
          path: "/admin/reports/pre-post-reports",
          name: "company.reports.pre-post-reports",
          component: () => import("@/view/company/Reports/PrePostReports.vue"),
          meta: { permission: "read_prepostreport" },
        },
        {
          path: "/admin/reports/metabase-report",
          name: "company.reports.metabase-report",
          component: () => import("@/view/company/Reports/MetabaseReport.vue"),
          meta: { permission: "read_report" },
        },
        {
          path: "/admin/reports/user-login-report",
          name: "company.reports.userLoginReport",
          component: () => import("@/view/company/Reports/UserLoginReport.vue"),
          meta: { permission: "read_report" },
        },
        {
          path: "admin/faq",
          name: "company.faq",
          component: () => import("@/view/User/FAQ"),
          meta: { permission: "read_faq" },
        },
        {
          path: "faq/list",
          name: "company.faq.list",
          component: () => import("@/view/company/Faq/List"),
          meta: { permission: "read_faq" },
        },
        {
          path: "faq/add",
          name: "company.faq.add",
          component: () => import("@/view/company/Faq/Add"),
          meta: { permission: "create_faq" },
        },
        {
          path: "/admin/faq/:id/edit",
          name: "company.faq.edit",
          component: () => import("@/view/company/Faq/Edit"),
          meta: { permission: "create_faq" },
        },

        {
          path: "faq-categories/list",
          name: "company.faq_categories.list",
          component: () => import("@/view/company/FaqCategories/List"),
          meta: { permission: "read_faq" },
        },
        {
          path: "faq-categories/add",
          name: "company.faq_categories.add",
          component: () => import("@/view/company/FaqCategories/Add"),
          meta: { permission: "create_faq" },
        },
        {
          path: "/admin/faq-categories/:id/edit",
          name: "company.faq_categories.edit",
          component: () => import("@/view/company/FaqCategories/Edit"),
          meta: { permission: "create_faq" },
        },
        {
          path: "/admin/wall/:user",
          name: "company.user.wall",
          props: true,
          component: () => import("@/view/User/Wall/index.vue"),
        },
        {
          path: "/admin/integrations",
          name: "company.integrations.list",
          component: () => import("@/view/company/Integrations/List"),
          meta: { permission: "read_integration" },
        },
        {
          path: "/admin/solution-partners",
          name: "company.solution-partners.list",
          component: () => import("@/view/company/SolutionPartners/List"),
          meta: { permission: "read_additionalapplication" },
        },
        {
          path: "/admin/leaders-table-management",
          name: "company.leaders.table.management",
          component: () =>
            import(
              "@/view/company/LeadersTableManagement/LeadersTableManagement.vue"
            ),
          meta: { permission: "read_leaderboardrule" },
        },
        {
          path: "/user-statistics/:user",
          name: "company.user.statistics",
          component: () => import("@/view/User/MyStatistics/index.vue"),
        },
        {
          path: "/admin/authorization-roles",
          name: "company.authorization.roles",
          component: () => import("@/view/company/Authorization/Roles.vue"),
          meta: { permission: "read_role" },
        },
        {
          path: "/admin/authorization-permission",
          name: "company.authorization.permission",
          component: () =>
            import("@/view/company/Authorization/Permission.vue"),
          meta: { permission: "read_permission" },
        },
        {
          path: "/admin/authorization-add-edit-roles/:id?",
          name: "company.authorization.add-edit-roles",
          component: () =>
            import("@/view/company/Authorization/AddEditRoles.vue"),
          meta: { permission: "create_role" },
        },
        {
          path: "/admin/authorization-add-permission/:id?",
          name: "company.authorization.add-edit-permission",
          component: () =>
            import("@/view/company/Authorization/AddEditPermission.vue"),
          meta: { permission: "read_permission" },
        },
      ],
    },
    {
      name: "login",
      path: "/login",
      component: () => import("@/view/auth/LoginResolver.vue"),
      beforeEnter: executeMiddleware(["redirectIfAuthenticated"]),
      // meta: { permission: "read_login" },
    },
    {
      path: "/confirm-access-code",
      name: "index.confirm-access-code",
      component: () => import("@/view/auth/ConfirmAccessCode"),
      beforeEnter: executeMiddleware(["redirectIfAuthenticated"]),
    },
    {
      path: "/forgot-password",
      name: "index.forgot-password",
      component: () => import("@/view/auth/ForgotPassword"),
      beforeEnter: executeMiddleware(["redirectIfAuthenticated"]),
    },
    {
      path: "/create-password",
      name: "index.create-password",
      component: () => import("@/view/auth/CreatePassword"),
    },
    {
      path: "/register",
      name: "index.register",
      component: () => import("@/view/auth/Register"),
      beforeEnter: executeMiddleware(["redirectIfAuthenticated"]),
    },
    {
      path: "/register-invitation/:params",
      name: "index.register-sign",
      component: () => import("@/view/auth/Register"),
    },
    {
      path: "/reset-password/:token",
      name: "index.reset-password",
      component: () => import("@/view/auth/ResetPassword"),
    },
    {
      path: "/email-verification",
      name: "index.email-verification",
      component: () => import("@/view/auth/EmailVerification"),
    },
    {
      // the 403 route, when access denied
      path: "/403",
      name: "403",
      component: () => import("@/view/error/403.vue"),
    },
    {
      // the 500 route, when access denied
      path: "/500",
      name: "500",
      component: () => import("@/view/error/500.vue"),
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/error/404.vue"),
    },
    {
      path: "/",
      name: "app",
      children: [
        {
          path: "/s/:id",
          component: () => import("@/App.vue"),
        },
      ],
    },
    {
      path: "/policies",
      name: "policies",
      component: () => import("@/view/homepage/policies.vue"),
    },
    // {
    //   path: "/contact",
    //   name: "contact",
    //   component: () => import("@/view/homepage/contact.vue"),
    // },
  ],
});

router.beforeEach((to, from, next) => {
  const isNative = !!window.ReactNativeWebView;

  if (
    isNative &&
    (to.path === "/" || to.path === "" || to.path === "/homepage")
  ) {
    return next("/dashboard");
  }

  if (to.path === "/" || to.path === "") {
    return next("/homepage");
  }

  if (to.path === "/homepage") {
    return next();
  }
  const requiredPermission = to.meta.permission;

  // 1️⃣ — Permission kontrolü
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return next({ name: "403" });
  }

  // 2️⃣ — Domain kontrolü
  const host = window.location.hostname;
  const isMainDomain = host === "softinya.com" || host === "www.softinya.com";

  if (isMainDomain && (to.path === "/" || to.path === "")) {
    return next("/homepage");
  }

  // 3️⃣ — Diğer durumlarda normal devam et
  next();
});

// Sayfa değiştiğinde scroll pozisyonunu sıfırla
router.afterEach((to, from) => {
  if (to.path !== from.path) {
    window.scrollTo(0, 0);
  }
  // Sayfa görüntülemelerini takip et
  GoogleAnalyticsService.trackPageView(to.fullPath);
});

export default router;
